import Vue from 'vue'
import App from './App'

import router from './router'
import store from './store'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueTouch from 'vue-touch'

// import config from './config/ENV'
// if (config.ENV === 'prod') {
//   console.log = function () { return }
// }

Vue.use(VueTouch, { name: 'v-touch' })
Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})
